module.exports = __webpack_public_path__ + "img/content_title6.e0e16c9a.png";